import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = {
  style: {"aspect-ratio":"1"},
  class: "rounded-borders bg-grey-3 overflow-hidden"
}
const _hoisted_3 = { class: "q-pt-md" }
const _hoisted_4 = ["title"]
const _hoisted_5 = ["title"]

import {useTracking} from 'src/etc/tracking';
import {PropType} from 'vue';
import {AdData} from 'src/apps/ads/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'VehicleSearchAdWrapper',
  props: {
  adData: {
    type: Object as PropType<AdData>,
    required: true
  }
},
  setup(__props) {

const props = __props

const tracker = useTracking()
const trackClick = function () {
  tracker.trackAdClick(props.adData.name)
}


return (_ctx: any,_cache: any) => {
  const _component_q_img = _resolveComponent("q-img")!
  const _directive_track_content = _resolveDirective("track-content")!

  return _withDirectives((_openBlock(), _createElementBlock("a", {
    href: __props.adData.link,
    rel: "external noopener nofollow",
    target: "_blank",
    style: {"text-decoration":"none","color":"inherit"},
    onClick: trackClick
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_q_img, {
        fetchpriority: "low",
        "no-spinner": "",
        alt: __props.adData.name,
        src: __props.adData.img,
        fit: __props.adData.fit ?? 'contain',
        class: "full-width full-height"
      }, null, 8, ["alt", "src", "fit"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: "ellipsis text-bold",
        title: __props.adData.title
      }, _toDisplayString(__props.adData.title), 9, _hoisted_4),
      _createElementVNode("div", {
        class: "text-small ellipsis-2-lines",
        title: __props.adData.shortText
      }, _toDisplayString(__props.adData.shortText), 9, _hoisted_5),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "text-muted text-xsmall" }, "Sponsored", -1))
    ])
  ], 8, _hoisted_1)), [
    [_directive_track_content, {
      target: __props.adData.link,
      piece: __props.adData.name,
      name: 'VehicleAd'
    }]
  ])
}
}

})